import { STATE_IDENTIFIER } from './constants'
import { IResponseState } from '../../../components/Modals/ResponseModal/module/constants'

const {
  STEP_ONE,
  STEP_ONE_OUS,
  STEP_ONE_LOADER,
  STEP_TWO,
  STEP_TWO_ACCOUNTS,
  STEP_TWO_LOADER,
  STEP_THREE,
  STEP_THREE_PWD_POLICY,
  STEP_THREE_CALL_STATE,
  CREATION,
  TU_APPLICATION,
  TU_DESCRIPTION,
  SELECTED_ACCOUNT,
  SELECTED_OU,
  SELECTED_OU_NAME,
  SELECTED_TU,
  IS_EDITING,
  APPLICATIONS,
  CATALOG_ENTITLEMENTS,
  CATALOG_ENTITLEMENTS_LOADER,
  TU_ENTITLEMENTS,
  TU_ENTITLEMENTS_LOADER,
  ADDED_ENTITLEMENTS,
  DELETED_ENTITLEMENTS,
  CREATION_CALL_STATE,
  CALL_STATE,
} = STATE_IDENTIFIER

const emptyState = {
  [CALL_STATE]: IResponseState.PENDING,
  [APPLICATIONS]: [],
  [IS_EDITING]: false,
  [SELECTED_ACCOUNT]: null,
  [SELECTED_OU]: null,
  [SELECTED_OU_NAME]: null,
  [SELECTED_TU]: null,
  [STEP_ONE]: {
    [STEP_ONE_OUS]: [],
    [STEP_ONE_LOADER]: false,
  },
  [STEP_TWO]: {
    [STEP_TWO_ACCOUNTS]: [],
    [STEP_TWO_LOADER]: false,
  },
  [STEP_THREE]: {
    [STEP_THREE_CALL_STATE]: IResponseState.PENDING,
    [STEP_THREE_PWD_POLICY]: {
      lastNpassword: 0,
      allowEmptyPassword: false,
      minLength: 0,
      maxLength: 99999,
      lowerCase: {
        min: 0,
        allowed: false,
      },
      upperCase: {
        min: 0,
        allowed: false,
      },
      numberChar: {
        min: 0,
        allowed: false,
      },
      specialChar: {
        min: 0,
        allowed: false,
        allowedCharList: [],
      },
    },
  },
  [CREATION]: {
    [CREATION_CALL_STATE]: IResponseState.PENDING,
    [TU_APPLICATION]: null,
    [TU_DESCRIPTION]: null,
    [CATALOG_ENTITLEMENTS]: [],
    [CATALOG_ENTITLEMENTS_LOADER]: false,
    [TU_ENTITLEMENTS]: [],
    [TU_ENTITLEMENTS_LOADER]: false,
    [ADDED_ENTITLEMENTS]: [],
    [DELETED_ENTITLEMENTS]: [],
  },
}

export default emptyState
